import { meta } from './meta';
import { contacts } from './contacts';
import { calendar } from './calendar';
import { mails, mailDrafts } from './mails';
import { pullRequests, receipts, bankTransactions, agentTasks } from './work';
import { weather } from './weather';
import { proposals } from './proposals';
import { traces } from './traces';
import { log } from './log';
import { rooms, devices } from './home';
import { moments } from './scenario';
import { voiceSuggestions, summonExamples } from './assistant';
import { diffs, slackMessages, renders, deskMoments, deskSuggestions, cloudCostByAgent, liveLogs } from './desk';
import { defaultHouseModes, defaultInitiative, defaultPersona, voices } from '../beheer/persona';
import { defaultPermissions } from '../beheer/permissions';
import { knowledge, memoryEvents, memoryProposals, workflows } from '../beheer/memory';
import type { Tables } from '../../types/db';

/** Seed of the fake database. The live, mutable copy lives in utils/db.ts. */
export const seed: Tables = {
  meta,
  contacts,
  calendar,
  mails,
  mailDrafts,
  pullRequests,
  receipts,
  bankTransactions,
  weather,
  agentTasks,
  proposals,
  traces,
  log,
  rooms,
  devices,
  moments,
  voiceSuggestions,
  summonExamples,
  diffs,
  slackMessages,
  renders,
  deskMoments,
  deskSuggestions,
  cloudCostByAgent,
  liveLogs,
  settings: {
    persona: defaultPersona,
    voiceId: voices[0].id,
    houseModes: defaultHouseModes,
    initiative: defaultInitiative,
    permissions: defaultPermissions,
  },
  memory: { proposals: memoryProposals, knowledge, workflows, events: memoryEvents },
};
